import {
    DELETEROLEMAPPING_SUCCESS,
    DELETEROLEMAPPING_FAILED,
    RESET_DELETEROLEMAPPING,
    LOADING_DELETEROLEMAPPING,
    NETWORK_ERROR_DELETEROLEMAPPING,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetDeleteRoleMapping = () => {
    return { type: RESET_DELETEROLEMAPPING };
};

const deleteRoleMapping = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DELETEROLEMAPPING });
    await adminServices
        .post("deleteRoleMapping", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(deleteRoleMappingsuccess(res.data));
                    break;
                default:
                    dispatch(deleteRoleMappingFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_DELETEROLEMAPPING, payload: err });
        });
};
function deleteRoleMappingsuccess(data) {
    return {
        type: DELETEROLEMAPPING_SUCCESS,
        payload: data,
    };
}
function deleteRoleMappingFailed(data) {
    return {
        type: DELETEROLEMAPPING_FAILED,
        payload: data,
    };
}

export { resetDeleteRoleMapping, deleteRoleMapping };
